const ContentTokens = Object.freeze({
  ADVISOR_NAME: 'ADVISOR_NAME',
  EMPLOYEES_ARE: 'EMPLOYEES_ARE',
  FIRST_NAME: 'FIRST_NAME',
});

export default ContentTokens;
